import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  IconSun,
  IconCloudSun,
  IconCloudRain,
  IconClouds,
  IconCloud,
  IconCloudFill,
  IconCloudLightning,
  IconCloudLightningRain,
  IconCloudLightningRainFill,
  IconCloudDrizzle,
  IconCloudRainHeavy,
  IconSnow,
  IconCloudSnow,
  IconCloudSleet,
  IconCloudHaze,
  IconCloudHaze1,
  IconCloudFog,
  IconCloudFog2,
  IconCloudSlash,
  IconTornado,
  IconHurricane,
  IconSnow2,
  IconWind,
  IconCloudHail,
  IconTropicalStorm,
} from "../../../assets/iconWeather";

import WeatherItem from "./Component/WeatherItem";
import { Bounce, Zoom, Slide } from "react-awesome-reveal";
import moment from "moment-jalaali";
import _ from "lodash";
import IconList from "./Component/Icon";
moment.locale("fa");
moment.loadPersian();
const Icons = {
  IconSun,
  IconCloudSun,
  IconCloudRain,
  IconClouds,
  IconCloud,
  IconCloudFill,
  IconCloudLightning,
  IconCloudLightningRain,
  IconCloudLightningRainFill,
  IconCloudDrizzle,
  IconCloudRainHeavy,
  IconSnow,
  IconCloudSnow,
  IconCloudSleet,
  IconCloudHaze,
  IconCloudHaze1,
  IconCloudFog,
  IconCloudFog2,
  IconCloudSlash,
  IconTornado,
  IconHurricane,
  IconSnow2,
  IconWind,
  IconCloudHail,
  IconTropicalStorm,
};
function Weather() {
  const [current, setCurrent] = useState({});
  const [daily, setDaily] = useState([]);

  let openweathermap = {
    lat: 26.5395,
    lon: 53.9759,
    timezone: "Asia/Tehran",
    timezone_offset: 12600,
    current: {
      dt: 1643186158,
      sunrise: 1643166692,
      sunset: 1643205681,
      temp: 296.14,
      feels_like: 296.27,
      pressure: 1018,
      humidity: 68,
      dew_point: 289.92,
      uvi: 5.19,
      clouds: 0,
      visibility: 8000,
      wind_speed: 3.09,
      wind_deg: 100,
      weather: [
        {
          id: 800,
          main: "Clear",
          description: "آسمان صاف",
          icon: "01d",
        },
      ],
    },
    daily: [
      {
        dt: 1643185800,
        sunrise: 1643166692,
        sunset: 1643205681,
        moonrise: 1643144520,
        moonset: 1643185560,
        moon_phase: 0.78,
        temp: {
          day: 295.85,
          min: 293.82,
          max: 296.14,
          night: 294.61,
          eve: 294.88,
          morn: 293.82,
        },
        feels_like: {
          day: 295.85,
          night: 294.14,
          eve: 294.47,
          morn: 293.27,
        },
        pressure: 1018,
        humidity: 64,
        dew_point: 288.7,
        wind_speed: 2.47,
        wind_deg: 137,
        wind_gust: 2.47,
        weather: [
          {
            id: 800,
            main: "Clear",
            description: "آسمان صاف",
            icon: "01d",
          },
        ],
        clouds: 0,
        pop: 0,
        uvi: 5.26,
      },
      {
        dt: 1643272200,
        sunrise: 1643253072,
        sunset: 1643292128,
        moonrise: 1643234820,
        moonset: 1643274540,
        moon_phase: 0.81,
        temp: {
          day: 295.01,
          min: 294.38,
          max: 295.22,
          night: 294.77,
          eve: 295,
          morn: 294.38,
        },
        feels_like: {
          day: 294.48,
          night: 294.42,
          eve: 294.55,
          morn: 293.81,
        },
        pressure: 1017,
        humidity: 47,
        dew_point: 283.28,
        wind_speed: 3.17,
        wind_deg: 96,
        wind_gust: 3,
        weather: [
          {
            id: 800,
            main: "Clear",
            description: "آسمان صاف",
            icon: "01d",
          },
        ],
        clouds: 0,
        pop: 0,
        uvi: 5.32,
      },
      {
        dt: 1643358600,
        sunrise: 1643339450,
        sunset: 1643378575,
        moonrise: 1643325240,
        moonset: 1643363940,
        moon_phase: 0.85,
        temp: {
          day: 294.52,
          min: 293.27,
          max: 294.66,
          night: 293.27,
          eve: 293.79,
          morn: 294.2,
        },
        feels_like: {
          day: 294.54,
          night: 292.75,
          eve: 293.37,
          morn: 293.98,
        },
        pressure: 1018,
        humidity: 70,
        dew_point: 288.96,
        wind_speed: 11.61,
        wind_deg: 294,
        wind_gust: 12.26,
        weather: [
          {
            id: 800,
            main: "Clear",
            description: "آسمان صاف",
            icon: "01d",
          },
        ],
        clouds: 3,
        pop: 0,
        uvi: 5.24,
      },
      {
        dt: 1643445000,
        sunrise: 1643425826,
        sunset: 1643465022,
        moonrise: 1643415780,
        moonset: 1643453820,
        moon_phase: 0.89,
        temp: {
          day: 294.09,
          min: 292.91,
          max: 294.32,
          night: 294.17,
          eve: 294.06,
          morn: 292.91,
        },
        feels_like: {
          day: 293.36,
          night: 293.71,
          eve: 293.56,
          morn: 292.22,
        },
        pressure: 1017,
        humidity: 43,
        dew_point: 280.78,
        wind_speed: 10.34,
        wind_deg: 288,
        wind_gust: 10.7,
        weather: [
          {
            id: 800,
            main: "Clear",
            description: "آسمان صاف",
            icon: "01d",
          },
        ],
        clouds: 6,
        pop: 0,
        uvi: 5.37,
      },
      {
        dt: 1643531400,
        sunrise: 1643512202,
        sunset: 1643551469,
        moonrise: 1643506200,
        moonset: 1643544120,
        moon_phase: 0.93,
        temp: {
          day: 294.78,
          min: 293.77,
          max: 294.97,
          night: 294.75,
          eve: 294.7,
          morn: 293.78,
        },
        feels_like: {
          day: 294.28,
          night: 294.45,
          eve: 294.4,
          morn: 293.26,
        },
        pressure: 1015,
        humidity: 49,
        dew_point: 283.19,
        wind_speed: 7.32,
        wind_deg: 295,
        wind_gust: 7.44,
        weather: [
          {
            id: 800,
            main: "Clear",
            description: "آسمان صاف",
            icon: "01d",
          },
        ],
        clouds: 0,
        pop: 0,
        uvi: 5.65,
      },
      {
        dt: 1643617800,
        sunrise: 1643598575,
        sunset: 1643637916,
        moonrise: 1643596260,
        moonset: 1643634660,
        moon_phase: 0.97,
        temp: {
          day: 295.56,
          min: 294.5,
          max: 295.56,
          night: 294.65,
          eve: 295.02,
          morn: 294.65,
        },
        feels_like: {
          day: 295.27,
          night: 294.53,
          eve: 294.88,
          morn: 294.34,
        },
        pressure: 1013,
        humidity: 54,
        dew_point: 285.8,
        wind_speed: 6.83,
        wind_deg: 294,
        wind_gust: 7.03,
        weather: [
          {
            id: 800,
            main: "Clear",
            description: "آسمان صاف",
            icon: "01d",
          },
        ],
        clouds: 0,
        pop: 0,
        uvi: 6,
      },
      {
        dt: 1643704200,
        sunrise: 1643684948,
        sunset: 1643724362,
        moonrise: 1643685900,
        moonset: 1643725200,
        moon_phase: 0,
        temp: {
          day: 295.24,
          min: 294.39,
          max: 295.24,
          night: 294.44,
          eve: 294.81,
          morn: 294.45,
        },
        feels_like: {
          day: 295.07,
          night: 294.24,
          eve: 294.65,
          morn: 294.2,
        },
        pressure: 1014,
        humidity: 60,
        dew_point: 287.09,
        wind_speed: 9.07,
        wind_deg: 293,
        wind_gust: 9.81,
        weather: [
          {
            id: 801,
            main: "Clouds",
            description: "کمی ابری",
            icon: "02d",
          },
        ],
        clouds: 19,
        pop: 0,
        uvi: 6,
      },
      {
        dt: 1643790600,
        sunrise: 1643771319,
        sunset: 1643810808,
        moonrise: 1643775120,
        moonset: 1643815620,
        moon_phase: 0.04,
        temp: {
          day: 294.88,
          min: 294.14,
          max: 295.16,
          night: 294.41,
          eve: 294.62,
          morn: 294.14,
        },
        feels_like: {
          day: 294.26,
          night: 294.13,
          eve: 294.23,
          morn: 293.7,
        },
        pressure: 1017,
        humidity: 44,
        dew_point: 282.06,
        wind_speed: 9.41,
        wind_deg: 294,
        wind_gust: 9.93,
        weather: [
          {
            id: 800,
            main: "Clear",
            description: "آسمان صاف",
            icon: "01d",
          },
        ],
        clouds: 0,
        pop: 0,
        uvi: 6,
      },
    ],
  };

  useEffect(() => {
    try {
      fetch(
        "https://api.openweathermap.org/data/2.5/onecall?lat=26.539511&lon=53.975914&exclude=minutely,hourly&lang=fa&appid=0a3c276720bcee1aa8a715c75969c8fd"
      )
        .then((res) => res.json())
        .then(
          (result) => {
            openweathermap = result;

            const CurrentTime = new Date(openweathermap.current.dt * 1000);
            setCurrent({
              jDay: moment(CurrentTime).format("dddd"),
              jMounth: moment(CurrentTime).format("jMMMM"),
              date: moment(CurrentTime).format("jYYYY/jMM/jDD"),
              temp: _.toInteger(openweathermap.current.temp - 273.15),
              maxTemp: _.toInteger(openweathermap.daily[0].temp.max - 273.15),
              minTemp: _.toInteger(openweathermap.daily[0].temp.min - 273.15),
              weatherDesc: openweathermap.current.weather[0].description,
              weatherIcon: FindIconInJson(openweathermap.current.weather[0].id),
              weatherMain: openweathermap.current.weather[0].main,
            });

            let dailyList = [];
            for (let i = 1; i < openweathermap.daily.length && i < 7; i++) {
              const item = openweathermap.daily[i];
              const dateTimeItem = new Date(item.dt * 1000);
              const dayItem = {
                jDay: moment(dateTimeItem).format("dddd"),
                jMounth: moment(dateTimeItem).format("jMMMM"),
                date: moment(dateTimeItem).format("jYYYY/jMM/jDD"),
                temp: _.toInteger(item.temp.day - 273.15),
                maxTemp: _.toInteger(item.temp.max - 273.15),
                minTemp: _.toInteger(item.temp.min - 273.15),
                weatherDesc: item.weather[0].description,
                weatherIcon: FindIconInJson(item.weather[0].id),
                weatherMain: item.weather[0].main,
              };
              dailyList.push(dayItem);
            }
            setDaily(dailyList);
          },
          (error) => {
            
          }
        );
    } catch (error) {
      
    }
  }, []);

  const FindIconInJson = (iconId) => {
    //
    let FindIcon = "";
    Object.entries(IconList).map(([key, value]) => {
      if (key === _.toString(iconId)) {
        // 
        // 
        FindIcon = value.icon;
      }
    });
    if (FindIcon === "") return "IconSun";
    return FindIcon;
  };

  const PrintIcon = (props) => {
    if (_.isEmpty(props)) props = "IconSun"; // پیش فرض
    const { [props]: Icon } = Icons;
    return <Icon fillColor="#022344" />;
  };

  return (
    <Container fluid={true} className="main-content weather-div">
      <Container>
        <Row className="h-100 pt-5">
          <Col
            xs={12}
            className="text-white text-center my-4 my-lg-5 large-svg"
          >
            <Row>
              <Col lg={5} className="text-center mb-3 mb-lg-0">
                <Zoom triggerOnce={true} className="h-100">
                  <div className="p-3 fs-102  text-center  h-100">
                    <div className="text-center pt-lg-4">
                      {" "}
                      آب و هوای جزیره کیش
                    </div>
                    <div className="text-center pt-1 pt-lg-3">
                      {" "}
                      امروز {current.jDay + "  " + current.date}{" "}
                    </div>
                  </div>
                </Zoom>
              </Col>
              <Col xs={12} lg={7} className="h-100">
                <Zoom triggerOnce={true}>
                  <div className=" transparent-box p-3">
                    <Zoom triggerOnce={true}>
                      <div
                        className=" text-center mb-2"
                        style={{ fontSize: "20px" }}
                      >
                        {PrintIcon(current.weatherIcon)}
                        {"   " + current.weatherDesc}
                      </div>
                    </Zoom>
                    <Zoom delay={300} triggerOnce={true}>
                      <div
                        style={{ fontSize: "65px" }}
                        className="ltr text-center"
                      >
                        {" "}
                        {current.temp}{" "}
                        <span style={{ fontSize: "25px" }}>°C</span>{" "}
                      </div>
                    </Zoom>
                    <Zoom delay={400} triggerOnce={true}>
                      <div className="mb-2 text-center ">
                        {current.maxTemp}
                        <span className="text-xsmall text-center">
                          °C{" "}
                        </span> / {current.minTemp}
                        <span className="text-xsmall">°C</span>{" "}
                      </div>
                    </Zoom>
                  </div>
                </Zoom>
              </Col>
            </Row>
            <Zoom delay={500} cascade={true} triggerOnce={true}>
              <div className="p-3 mt-3 text-center transparent-box">
                {daily?.length > 0 ? (
                  <Row>
                    {daily?.map((item, index) => (
                      <WeatherItem
                        key={index}
                        ItemDay={item.jDay}
                        ItemIcon={PrintIcon(item.weatherIcon)}
                        ItemHightTemp={item.maxTemp}
                        ItemlowTemp={item.minTemp}
                      />
                    ))}
                    {/* <WeatherItem ItemDay="سه شنبه" ItemIcon={<CloudSun />} ItemHightTemp="28" ItemlowTemp="20" />
                                    <WeatherItem ItemDay="چهار شنبه" ItemIcon={<CloudHaze />} ItemHightTemp="27" ItemlowTemp="19" />
                                    <WeatherItem ItemDay="پنج شنبه" ItemIcon={<CloudRain />} ItemHightTemp="26" ItemlowTemp="18" />
                                    <WeatherItem ItemDay="جمعه" ItemIcon={<Clouds />} ItemHightTemp="25" ItemlowTemp="17" />
                                    <WeatherItem ItemDay="شنبه" ItemIcon={<Cloud />} ItemHightTemp="24" ItemlowTemp="16" />
                                    <WeatherItem ItemDay="یک شنبه" ItemIcon={<CloudFill />} ItemHightTemp="24" ItemlowTemp="16" /> */}
                  </Row>
                ) : (
                  <></>
                )}
              </div>
            </Zoom>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Weather;
